
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  mounted: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7; // Loading flag

    var allowInfinite = true; // Attach 'infinite' event handler
    //console.log($$('.notifications-infinite-scroll-content'));

    $$('.notifications-infinite-scroll-content').on('infinite', function () {
      // Exit, if loading in progress
      if (!allowInfinite) return; // Set loading flag

      allowInfinite = false;
      $$('.notifications-infinite-scroll-content .infinite-scroll-preloader').removeClass("display-none"); //console.log("Infinite");

      self.loadNotifications(function () {
        // Reset loading flag
        allowInfinite = true;
        $$('.notifications-infinite-scroll-content .infinite-scroll-preloader').addClass("display-none");
      }, function () {
        allowInfinite = true;
      });
    });
    $$('.notifications-ptr-content').on('ptr:refresh', function (e) {
      //console.log("ptr:refresh");
      self.$setState({
        nextPage: {
          href: Url.to("notification/list?per-page=15")
        },
        notifications: []
      }, function () {});
      self.$tick(function () {
        self.loadNotifications(function () {
          // Reset loading flag
          app.ptr.done('.notifications-ptr-content');
          app.infiniteScroll.create('.notifications-infinite-scroll-content'); //$$('.notifications-infinite-scroll-content .infinite-scroll-preloader').removeClass("display-none");
        });
      });
    });
  },
  beforeMount: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;
    var ptr = app.ptr.get('.notifications-ptr-content'); //Get articles

    $$(".view-notifications").once("tab:show", function () {
      $$('.notifications-infinite-scroll-content .infinite-scroll-preloader').removeClass("display-none");
      self.loadNotifications(function () {
        $$('.notifications-infinite-scroll-content .infinite-scroll-preloader').addClass("display-none");
      });
    });
  },
  methods: {
    openNotification: function (index) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var router = self.$router;
      var notification = self.notifications[index];
      var action = self.notifications[index]['mobile_action'];
      console.log(action);

      if (!self.notifications[index]['seen']) {
        app.request({
          url: Url.to("notification/read"),
          preloader: false,
          progress: false,
          method: "POST",
          data: {
            id: self.notifications[index]['id']
          },
          success: function (data, status, xhr) {
            self.notifications[index]['seen'] = true;
            self.$update();
          }
        });
      }

      console.log(action);

      if (action) {
        if (action['action'] == "view-service") {
          var id = action['id'];

          if (id) {
            app.request({
              url: Url.to("repair/request-details/" + id),
              preloader: true,
              progress: false,
              success: function (data, status, xhr) {
                router.navigate("/request-details/", {
                  context: {
                    request: data,
                    backButton: "Back"
                  }
                });
              }
            });
          }
        }

        if (action['action'] == "view-contract") {
          var id = action['id'];

          if (id) {
            app.request({
              url: Url.to("contract/contract-details/" + id),
              preloader: true,
              progress: false,
              success: function (data, status, xhr) {
                router.navigate("/contract/", {
                  context: {
                    contract: data,
                    backButton: "Back"
                  }
                });
              }
            });
          }
        }

        if (action['action'] == "view-article") {
          var id = action['id'];

          if (id) {
            app.request({
              url: Url.to("news/article/" + id),
              preloader: true,
              progress: false,
              success: function (data, status, xhr) {
                router.navigate("/article/", {
                  context: {
                    article: data,
                    backButton: "Back"
                  }
                });
              }
            });
            self.deleteNotification(self.notifications[index]['id']);
          }
        }

        if (action['action'] == "open-popup") {
          var ndialog = self.$app.dialog.alert('', notification['title'], function () {
            self.deleteNotification(self.notifications[index]['id']);
          });
          $$(ndialog.el).addClass("notification-dialog");
          $$(ndialog.el).find(".dialog-button:last-child").text("Close");
          console.log(ndialog);
        }

        if (action['action'] == "open-call-popup") {
          var tel = action['tel'];
          var ndialog = self.$app.dialog.confirm('', notification['title'], function () {
            self.deleteNotification(self.notifications[index]['id']);
          }, function () {
            if (window.cordova) {
              cordova.InAppBrowser.open('tel:' + tel, '_system', 'location=yes');
            } else {
              window.open('tel:' + tel, "_system");
            }

            self.deleteNotification(self.notifications[index]['id']);
          });
          $$(ndialog.el).addClass("notification-dialog");
          $$(ndialog.el).find(".dialog-button:first-child").text("Call");
          $$(ndialog.el).find(".dialog-button:last-child").text("Close");
          console.log(ndialog);
        }

        if (action['action'] == "open-change-password") {
          router.navigate("/change-password/", {
            context: {//preventBack: false,
              //extraMessage: "Password expired, please set a new password",
            }
          });
          self.deleteNotification(self.notifications[index]['id']);
        }
      }
    },

    deleteNotification(id) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.request({
        url: Url.to("notification/delete"),
        preloader: false,
        progress: false,
        method: "POST",
        data: {
          id: id
        },
        success: function (data, status, xhr) {}
      });
    },

    loadNotifications: function (callback, end) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;

      end = end || function () {};

      if (self.nextPage) {
        app.request({
          url: self.nextPage['href'],
          preloader: false,
          progress: true,
          success: function (data, status, xhr) {
            console.log("Notifications", data); //console.log("Notifications", data, data['links']['next']);

            self.$setState({
              notifications: self.notifications.concat(data['items']),
              nextPage: data['links']['next']
            }, function () {});
            $$("#notifications-count").addClass("display-none");
            self.$tick(function () {
              callback();
            });
          }
        });
      } else {
        end();
        app.infiniteScroll.destroy('.notifications-infinite-scroll-content'); //$$('.notifications-infinite-scroll-content .infinite-scroll-preloader').remove();

        $$('.notifications-infinite-scroll-content .infinite-scroll-preloader').addClass("display-none");
      }
    },

    openCountrySwitcher() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.request({
        url: Url.to("notification/unread"),
        preloader: true,
        progress: false,
        success: function (data, status, xhr) {
          var buttons = [];
          Object.keys(window.identity['countries']).forEach(country_code => {
            var listHtml = `<div class="list no-hairlines no-margin-top"><ul style="background: transparent">`;
            listHtml += `
                                <li>
                                    <a href="#" class="item-link item-content" data-country="${country_code}" data-name="${window.identity['countries'][country_code]}">
                                        <div class="item-media"><i class="iti__flag iti__${country_code}"></i></div>
                                        <div class="item-inner">
                                            <div class="item-title text-color-black" style="line-height: normal;">${window.identity['countries'][country_code]}</div>` + (data['countries'][country_code] > 0 ? `<div class="item-after"><span class="badge bg-color-red">${data['countries'][country_code]}</span></div>` : ``) + `</div>
                                    </a>
                                </li>`;
            listHtml += `</ul></div>`;
            buttons.push({
              text: listHtml,

              onClick() {
                window.switchToCountry(country_code);
              }

            });
          });
          app.dialog.create({
            title: "Select country",
            //text: '',
            //content: fullHtml,
            verticalButtons: true,
            buttons: buttons,
            on: {}
          }).open();
        }
      });
    }

  },
  data: function () {
    return {
      nextPage: {
        href: Url.to("notification/list?per-page=15")
      },
      notifications: [],
      country: window.country,
      allowCountrySwitch: Object.keys(window.identity['countries']).length > 1
    };
  },
  id: 'ac5c71ea19',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page navbar-extra-large" data-name="notifications">\n        <!-- Top Navbar -->\n        <div class="navbar navbar-large navbar-extra-large">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                </div>\n                <div class="title sliding">Notifications</div>\n                <div class="right">\n                </div>\n                <div class="title-large">\n                    <div class="title-large-text">\n                        Notifications\n                        <div class="right" style="top:0">\n                            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.allowCountrySwitch, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <a class="link icon-only my-countries-select" href="#" @click="openCountrySwitcher">\n                                <div class="iti__flag iti__';
          r += c(ctx_2.country, ctx_2);
          r += ' icon f7-icons" style="position: relative">\n                                    <small class="badge color-red" id="other-countries-notifications"\n                                           style="--f7-badge-in-icon-size: 10px;\n                                           margin-left: -5px;top: -4px;"></small>\n                                </div>\n                            </a>\n                            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </div>\n                        <div class="subtitle-text">Messages and reports</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="page-content notifications-infinite-scroll-content\n             infinite-scroll-content notifications-ptr-content ptr-content">\n            <div class="ptr-preloader">\n                <div class="preloader"></div>\n                <div class="ptr-arrow"></div>\n            </div>\n            <div class="list notifications-list no-hairline-top no-hairline-bottom">\n                <ul>\n                    ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.notifications, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <li>\n                        <a @click="openNotification(';
          r += c(data_2 && data_2.index, ctx_2);
          r += ')" class="item-link item-content " href="#">\n                            <div class="item-inner">\n                                <div class="item-title" style="white-space: normal;">\n                                    <div class="item-header">';
          r += c(ctx_2.created_at_relative, ctx_2);
          r += '</div>\n                                    <span class="';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.seen, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'text-color-primary';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '">';
          r += c(ctx_2.title, ctx_2);
          r += '</span>\n                                    <div class="item-footer">';
          r += c(ctx_2.message, ctx_2);
          r += '</div>\n                                </div>\n\n                            </div>\n                        </a>\n                    </li>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                </ul>\n            </div>\n            <div class="preloader infinite-scroll-preloader display-none"></div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    